/**
 * Re-export shim. The `ProgramKeyStats` **View** (props-only) was hoisted into
 * `@solomon-apps/shared/src/widgets/yaas/programs` so external consumers (the
 * "+New Program" Viewing-Program wiki doc) can render the bare key-stats row
 * fixture-driven, with no wallet / RPC / orgApiFetch. The hoisted module also
 * carries the generic `KeyStatsRow` mechanism + `KeyStat` type (structurally
 * identical to the app's Dashboard `KeyStatsRow` / `KeyStat`).
 *
 * The data-owning Container (`ProgramKeyStatsContainer`) stays app-side — it
 * still builds the `KeyStat[]` from the mock participant helpers and imports
 * this View from this path unchanged. The app's `KeyStat` (from the Dashboard
 * `PortfolioKeyStats`) is structurally identical to the shared one, so the
 * Container's stats flow straight through.
 *
 * @see packages/shared/src/widgets/yaas/programs/ProgramKeyStats.tsx
 */
export {
    ProgramKeyStats,
    KeyStatsRow,
    type ProgramKeyStatsProps,
    type KeyStat
} from "@solomon-apps/shared/src/widgets/yaas/programs/ProgramKeyStats";
